import React, {useState} from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import Form, { Actions, RequiredValidator, Switch, TextArea } from '../../Components/Form';
import { useUser } from '../../Data/Users';
import Button from '../../Components/Button/Button';
import { useHelp } from '../../Components/Help';
import { useNavigate } from 'react-router-dom';
import ButtonRow from '../../Components/Button/ButtonRow';
import { useSession } from '../../Components/Session';

const CloseAccount = () => {
    const {closeAccount} = useUser();
    const {openLiveChat} = useHelp();
    const navigate = useNavigate();
    const [startConfirming, setStartConfirming] = useState(false);
    const {logout} = useSession();

    const handleSubmit = async (data) => {
        await closeAccount(data);
        await logout();
        window.location.reload();
    }

    return <>
        <TopBar left="BackBtn" title="Close Account" />

        <Page>

            <div className="prose">
                <p>We're sorry to see you're thinking about closing your account.</p>
                <p>We won't make this difficult, but if you're having issues please know you can reach out to us at any time and we'll do our best to resolve any issues you're having.</p>

                <ButtonRow arrange="betweenAround">
                    <Button theme="primary" onClick={() => { navigate('/more', {replace: true}); openLiveChat()}} label="Support" />
                    <Button theme="primary" onClick={() => navigate('/more/help', {replace: true})} label="Search help" />
                    <Button theme="danger" onClick={() => setStartConfirming(true)} label="Close account" />
                </ButtonRow>
            </div>

            {startConfirming && <Form onSubmit={handleSubmit}>
                <p className="mt-5">
                    Closing account will delete ALL of your data.<br />
                    Please confirm you wish us to delete the following:
                </p>
                <Switch name="deleteCustomers" label="Delete Customers" validators={[RequiredValidator]} />
                <Switch name="deletePayments" label="Delete Payments" validators={[RequiredValidator]} />
                <Switch name="deleteWork" label="Delete Work History" validators={[RequiredValidator]} />
                <Switch name="deleteWebsite" label="Delete Website" validators={[RequiredValidator]} />
                <Switch name="deleteExpenses" label="Delete Expenses" validators={[RequiredValidator]} />
                <TextArea name="reason" label="Why are you closing your account?" validators={[RequiredValidator]} />
                <Actions submit={{label: 'Close account'}} />
            </Form>}

        </Page>
    </>
}

export default CloseAccount;
